import styled from "styled-components";

import { PIC } from "@ryde/assets";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, deepPurpleMui, rydeColors } from "@ryde/theme";

export const PassengersMapStationInfoPopupStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "passenger-map-station-info-container",
  },
)`
  width: 188px;
  padding: 0px;

  .station-info-header {
    text-align: start;
    color: ${blueGreyMui._500};
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid ${rydeColors.softGray};
    margin-bottom: 5px;
    padding-bottom: 5px;
  }

  .content {
    padding: 10px 0px;
    max-height: 135px;
    overflow: auto;
    scrollbar-width: thin;

    .passenger-row {
      display: flex;
      align-items: center;
      gap: 10px;
      position: relative;

      .passenger-icon {
        cursor: pointer;
      }

      .passenger-info {
        span {
          display: inline-flex;
          align-items: center;

          &:first-of-type::after {
            content: "";
            display: inline-block;
            width: 1px;
            height: 1.1em;
            background: ${rydeColors.black};
            margin-inline: 6px;
          }
        }

        .first-line {
          text-align: start;
          color: ${rydeColors.softGray};

          .passenger-name {
            font-weight: 700;
          }

          &.selected {
            color: ${deepPurpleMui.A700};
          }
        }

        .second-line {
          text-align: start;
          color: ${rydeColors.grey};
          font-size: 12px;
          font-weight: 400;
        }
      }
    }

    .passenger-row:not(:last-child) {
      margin-bottom: 15px;
    }

    .inactive-btn-container {
      color: ${rydeColors.passInBlue};
      font-size: 14px;
      font-weight: 400;
      display: flex;
      height: 32px;
      align-items: center;
      justify-content: center;
      gap: 6px;
      border-top: 1px solid ${rydeColors.rowHighlight};
      border-bottom: 1px solid ${rydeColors.rowHighlight};
      cursor: pointer;

      &.expend {
        margin-bottom: 15px;
      }
    }

    .empty-content {
      text-align: center;
      margin-bottom: 10px;
    }
  }

  .footer {
    height: 32px;
    padding: 0 8px;
    gap: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid ${rydeColors.rowHighlight};

    .edit-button {
      color: ${rydeColors.passInBlue};
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
    }
  }
`;

export const ExpandInactiveCollapseIconStyled = styled(PIC.FilledArrowSvg)<{
  $isExpanded: boolean;
}>`
  transform: rotate(
    ${({ $isExpanded: isExpanded }) => (isExpanded ? "0deg" : "180deg")}
  );
`;
